import React from 'react';
import './Splash.css';
import PropTypes from 'prop-types';

const Splash = props => {
  const { style, title } = props;
  return (
    <div className="splash home-splash" style={style}>
      <h1 className="splash-title">{title}</h1>
    </div>
  )
}

Splash.propTypes = {
  style: PropTypes.object,
  title: PropTypes.string.isRequired
}

export default Splash;


// WEBPACK FOOTER //
// ./src/components/Splash.js